import { render } from "./ForgeRockMilestones.vue?vue&type=template&id=7bf7c600&scoped=true&ts=true"
import script from "./ForgeRockMilestones.vue?vue&type=script&lang=ts"
export * from "./ForgeRockMilestones.vue?vue&type=script&lang=ts"

import "./ForgeRockMilestones.vue?vue&type=style&index=0&id=7bf7c600&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bf7c600"]])

export default __exports__